import Color from 'color';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import InputMask from 'react-input-mask';
import { CSSTransition } from 'react-transition-group';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import onClickOutside from 'react-onclickoutside';
import { Scrollbars } from 'react-custom-scrollbars';
import { defaultTheme } from '../../constants/appConfig';
import AnimatedErrorMessage from './AnimatedErrorMessage';
import { FormContext } from './Form';

const StyledUiSelect = styled.div`
  .select-arrow {
    &:before {
      border-left: 1px solid #C8C8C8;
      border-bottom: 1px solid #C8C8C8;
    }
  }
  .input-wrap {
    &:hover {
      &:before {
        background-color: ${Color('#d6d5d6').darken(0.2).hex()};
      }
      .select-arrow {
        &:before {
          border-left: 1px solid ${Color('#C8C8C8').darken(0.2).hex()};
          border-bottom: 1px solid ${Color('#C8C8C8').darken(0.2).hex()};
        }
      }
    }
  }
  &.focused {
    .input-wrap {
      &:before {
        background-color: ${props => (props.theme ? props.theme.primaryBgColor : defaultTheme.primaryBgColor)};
      }
    }
  }
  &.focused,
  &.filled {
    .input-wrap {
      .select-arrow {
        &:before {
          border-left: 1px solid ${props => (props.theme ? props.theme.primaryBgColor : defaultTheme.primaryBgColor)};
          border-bottom: 1px solid ${props => (props.theme ? props.theme.primaryBgColor : defaultTheme.primaryBgColor)};
        }
      }
    }
    .stroke-colored-el {
      stroke: ${props => (props.theme ? props.theme.primaryBgColor : defaultTheme.primaryBgColor)};
    }
    .fill-colored-el {
      fill: ${props => (props.theme ? props.theme.primaryBgColor : defaultTheme.primaryBgColor)};
    }
  }
  &.invalid {
    .input-wrap {
      &:before {
         background-color: #ff5252;
      }
    }
  }
  .select-item {
    &.focused {
      background-color: ${props => Color(props.theme ? props.theme.primaryBgColor : defaultTheme.primaryBgColor).fade(0.96).string()};
    }
    &.selected {
      color: ${props => (props.theme ? props.theme.primaryBgColor : defaultTheme.primaryBgColor)};
    }
    &:hover {
      color: ${props => (props.theme ? props.theme.primaryBgColor : defaultTheme.primaryBgColor)};
    }
  }
`;

class Autocomplete extends React.PureComponent {
  static propTypes = {
    value: PropTypes.any.isRequired,
    className: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.any,
      name: PropTypes.string,
    })).isRequired,
    label: PropTypes.string,
    valid: PropTypes.bool,
    message: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    customWidth: PropTypes.number,
    onChange: PropTypes.func,
    onSearch: PropTypes.func,
    onToggle: PropTypes.func,
    onScrollHeightUpdate: PropTypes.func,
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: '',
    label: '',
    valid: undefined,
    message: '',
    placeholder: '',
    disabled: false,
    customWidth: 100,
    onChange: () => {},
    onSearch: () => {},
    onToggle: () => {},
    onScrollHeightUpdate: () => {},
  };

  static contextType = FormContext;

  constructor(props) {
    super(props);

    this.state = {
      opened: false,
      focused: false,
      focusedItem: 0,
      currentInputValue: '',
    };

    this.selectEl = React.createRef();

    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    if (this.context) {
      this.context.onInputAddedToForm(this.selectEl.current);
    }

    window.document.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    window.document.removeEventListener('keydown', this.onKeyDown);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.value !== this.props.value && this.props.value !== '') {
      this.setState({ currentInputValue: this.props.value });
    }
  }

  onItemClick(item) {
    if (item.disabled) {
      return;
    }

    // this.setState({ focusedItem: this.props.items.findIndex(i => item.value === i.value) });

    this.toggle();
    this.props.onChange(item.value);
    // this.selectEl.current.blur(); todo test
  }

  onKeyDown = (e) => {
    const { items } = this.props;
    const { focused, opened, focusedItem, currentInputValue } = this.state;
    const actualFilteredItems = items.filter(item => item.name.toUpperCase().includes(currentInputValue.toUpperCase()));
    // const filteredItems = items.filter(item => item.value !== value);

    if (e.keyCode === 38 && opened) {
      e.preventDefault();
      this.setState(prevState => ({ focusedItem: prevState.focusedItem > 0 ? prevState.focusedItem - 1 : 0 }), () => {
        const scrollWrap = this.scrollInner.parentElement;
        const focusEl = this.scrollInner.getElementsByClassName('select-item')[this.state.focusedItem];
        if (scrollWrap.scrollTop > focusEl.offsetTop) {
          scrollWrap.scrollTop = focusEl.offsetTop;
        }
      });
    }

    if (e.keyCode === 40 && opened) {
      e.preventDefault();
      this.setState(prevState => ({
        focusedItem: prevState.focusedItem + 1 >= actualFilteredItems.length ? prevState.focusedItem : prevState.focusedItem + 1,
      }), () => {
        // const scrollWrap = this.scrollInner.parentElement;
        // const focusEl = this.scrollInner.getElementsByClassName('select-item')[this.state.focusedItem];
        // console.log('this.scrollInner.getElementsByClassName(\'select-item\') ', this.scrollInner.getElementsByClassName('select-item'), this.state.focusedItem)
        // if (focusEl.offsetTop - scrollWrap.scrollTop > scrollWrap.clientHeight - focusEl.clientHeight) {
        //   scrollWrap.scrollTop = (focusEl.offsetTop - scrollWrap.clientHeight) + focusEl.clientHeight;
        // }
        // todo из за не константного количества айтемов это не работает
      });
    }

    if ((e.keyCode === 13 || e.keyCode === 32) && focused) {
      e.preventDefault();
      this.toggle();
      if (opened && !actualFilteredItems[focusedItem].disabled) {
        this.props.onChange(actualFilteredItems[focusedItem].value);
        this.selectEl.current.blur();
      }
    }
  };

  onFocus = () => {
    this.props.onFocus();
    this.setState({ focused: true });
  };

  onBlur = () => {
    this.props.onBlur();
    this.setState({ focused: false });
  };

  getLabelByValue(value) {
    const item = this.props.items.find(i => i.value === value);

    if (this.props.value === '') {
      return this.props.placeholder;
    }

    if (!item) {
      throw new Error(`Value not found: ${value}`);
    }

    return item.name;
  }

  getItems() {
    const { items, value } = this.props;
    const { focusedItem, currentInputValue = '' } = this.state;
    return items.filter(item => item.name.toUpperCase().includes(currentInputValue.toUpperCase())).map((item, i) => (
      <div
        key={item.value}
        className={classnames('select-item', { selected: item.value === value, disabled: item.disabled, focused: focusedItem === i })}
        onClick={() => this.onItemClick(item)}
      >
        {item.name}
      </div>
    ));
  }

  toggle(forced = false) {
    const opened = (!this.state.opened && !this.props.disabled) || forced;
    const newState = { opened };
    if (!this.state.opened) {
      newState.focusedItem = 0;
    } else {
      this.selectEl.current.blur();
    }

    this.setState(newState, () => {
      // const scrollWrap = this.scrollInner.parentElement;
      // const focusEl = this.scrollInner.getElementsByClassName('select-item')[0];
      //
      // if (scrollWrap.scrollTop > focusEl.offsetTop) {
      //   scrollWrap.scrollTop = focusEl.offsetTop;
      // }
      //
      // if (focusEl.offsetTop - scrollWrap.scrollTop > scrollWrap.clientHeight - focusEl.clientHeight) {
      //   scrollWrap.scrollTop = (focusEl.offsetTop - scrollWrap.clientHeight) + focusEl.clientHeight;
      // }
    });
  }

  handleClickOutside() {
    this.setState({
      opened: false,
    });
  }

  onUiSelectClick = (e) => {
    if (this.state.opened && e.target.classList.contains('ui-select')) {
      this.setState({
        opened: false,
      });
    }
  };

  updateValue = (e) => {
    this.props.onSearch(e.target.value || '');
    this.setState({ currentInputValue: e.target.value || '', focusedItem: 0 }, () => {
      this.toggle(true);
      if (this.props.value !== this.state.currentInputValue) {
        this.props.onChange('');
      }
    });
  }

  render() {
    const items = this.getItems();

    const {
      value, label, className, disabled, valid, message, customWidth, onScrollHeightUpdate,
    } = this.props;
    const { opened, focused, currentInputValue } = this.state;

    const classname = classnames('ui-select', className, {
      disabled,
      notSelected: value === '',
      opened: opened && !disabled,
      focused,
      filled: value && value.length,
      valid: valid === true,
      invalid: valid === false,
    });

    // currentInputValue

    return (
      // eslint-disable-next-line
      <StyledUiSelect className={classname} style={{ width: `${customWidth}%` }} >
        <div
          className="input-wrap select-inner"
          ref={this.selectEl}
          onClick={this.toggle}
          tabIndex="0"
          onFocus={this.onFocus}
          onBlur={this.onBlur}
        >
          <div className="select-wrap">
            <InputMask
              className="select-value"
              value={currentInputValue}
              onChange={this.updateValue}
            />
          </div>
          <span className="select-arrow" />
        </div>
        <AnimatedErrorMessage in={valid === false} onScrollHeightUpdate={onScrollHeightUpdate}>
          <span dangerouslySetInnerHTML={{ __html: message }} />
        </AnimatedErrorMessage>
        <CSSTransition
          classNames="select-items"
          timeout={150}
          in={opened && !disabled}
          mountOnEnter
          unmountOnExit
        >
          <div className="select-items">
            <Scrollbars
              ref={ref => this.scroll = ref}
              autoHeight
              autoHeightMin={0}
              autoHeightMax={166}
              renderTrackVertical={props => <div {...props} className="ui-track-vertical" />}
              renderThumbVertical={props => <div {...props} className="ui-thumb-vertical" />}
            >
              <div className="select-items-inner" ref={ref => this.scrollInner = ref}>
                {items}
              </div>
            </Scrollbars>
          </div>
        </CSSTransition>

      </StyledUiSelect>
    );
  }
}

export default withTranslation([], { withRef: true })(onClickOutside(Autocomplete));
